import CreateVehicleHtml from './templates/vehicle.create.html';
import ListVehicleHtml   from './templates/vehicle.list.html';
import VehicleInfoHtml   from '../../app-lite/vehicles/templates/vehicle.info.html';

export function InvoiceVehicleSelectionCtrl (
  $q,
  $rootScope,
  $scope,
  $state,
  $translate,
  $urlService,
  $window,
  blockUI,
  carfaxApi,
  confirm,
  dvlaLookupApi,
  haynesProApi,
  jsonApi,
  messages,
  sessionObjAPI,
  Tiremetrix,
  vehicleRegistrationApi,
  vehicleApi,
  vehicleHistoryApi,
  workshopAPI
) {
  $scope.block               = blockUI.instances.get('vehicleSelectionBlock');
  $scope.company             = sessionObjAPI.company();
  $scope.fleetCodeLabel      = $scope.company.company_variable_fields.fleet_code_name || $translate.instant('VEHICLE_SPACE.FLEET_CODE');
  $scope.formContent         = $scope.vehicle.id ? VehicleInfoHtml : ListVehicleHtml;
  $scope.originalVin         = $scope.vehicle.vin;
  $scope.regoLabel           = $scope.company.company_variable_fields.plate_number_name || sessionObjAPI.countrySettings().rego_label;
  $scope.showInvoiceVehicle  = false;
  $scope.vehicle.plate_state = $scope.vehicle.plate_state || $scope.customer.state;
  $scope.vinLabel            = $scope.company.company_variable_fields.vin_name || $translate.instant('VEHICLE_SPACE.VIN');

  $scope.Tiremetrix = new Tiremetrix();

  $scope.columns = [
    {
      field : 'plate_number',
      header: {
        text: $scope.regoLabel
      }
    },
    {
      field : 'make',
      header: {
        text: $translate.instant('VEHICLE_SPACE.MAKE')
      }
    },
    {
      field : 'model',
      header: {
        text: $translate.instant('VEHICLE_SPACE.MODEL')
      }
    },
    {
      field : 'model_code',
      header: {
        text: $translate.instant('VEHICLE_SPACE.MODEL_CODE')
      }
    },
    {
      field : 'model_series',
      header: {
        text: $translate.instant('VEHICLE_SPACE.MODEL_SERIES')
      }
    }
  ];

  if ($scope.company.company_settings.show_fleet_code) {
    $scope.columns.push({
      field : 'fleet_code',
      header: {
        text: $scope.fleetCodeLabel
      }
    });
  }

  $scope.filtering = {
    value: ''
  };

  $scope.tableSettings = {
    broadcast: 'filterVehicles',
    columns  : $scope.columns,
    empty    : {
      text: $translate.instant('QUERY_DROPDOWN_SPACE.GRID.NO_VEHICLES_FOUND')
    },
    pagination: {
      enabled   : true,
      pageSize  : 5,
      pageSizes : [ 5, 10, 25, 50 ],
      queryCount: () => workshopAPI.get('/customers/vehicle_count', $scope.customer.id)
    },
    rows: {
      highlight: {
        enabled: true
      }
    },
    sorting: {
      direction: 'asc',
      enabled  : true,
      field    : 'plate_number'
    },
  };

  $scope.onRowClick = function (event) {
    $scope.vehicleSelected(event.row);
  };

  $scope.carfaxHistory = function () {
    carfaxApi.findHistory($scope.vehicle)
    .then(() => {
      $state.reload();
    })
    .catch(err => {
      messages.error(err);
    });
  };

  $scope.checkPlateNumber = function (form) {
    if ($scope.vehicle.plate_number) {
      return workshopAPI.get('/vehicle/verify_plate_uniqueness', $scope.vehicle.plate_number)
      .then(unique => {
        unique = jsonApi.parse(unique);

        form.plate_number.duplicate = !unique;

        return unique;
      });
    }

    form.plate_number.duplicate = false;

    return $q.when();
  };

  $scope.checkVin = function ( value ) {
    return $scope.originalVin === value
      ? $q.when(true)
      : vehicleApi.checkVinUniqueness(value);
  };

  $scope.close = function () {
    $scope.$broadcast('close');
  };

  $scope.createFromOtherBranch = function () {
    vehicleApi.createVehicleFromOtherBranch($scope.vehicle.customer_id)
    .then(results => {
      $state.go($urlService.path().indexOf('invoice') > -1 ? 'app.invoice': 'app.event', {
        customer_id: results.vehicle.customer_id,
        vehicle_id : results.vehicle.id
      });

      messages.show('Vehicle Saved', 'success');

      $scope.vehicleSelected(results.vehicle);
    });
  };

  $scope.createVehicle = function () {
    $scope.formContent = CreateVehicleHtml;
  };

  $scope.getVehicles = ( params ) => {
    return workshopAPI.get('/customers/vehicle_list_with_find', [
      $scope.customer.id,
      $scope.filtering.value || '*',
      params.offset,
      params.pageSize,
      params.field,
      params.direction
    ]).then(function (vehicles) {
      $scope.vehicles = vehicles;
      return vehicles;
    });
  };

  $scope.viewTireDetails = function () {
    vehicleRegistrationApi.viewTireDetails($scope.vehicle);
  };

  $scope.hasVehicleRegistrationId = function () {
    return vehicleRegistrationApi.hasRegistrationId($scope.vehicle);
  };

  $scope.init = function () {
    if ($scope.customer.id && !$scope.vehicle.id) {
      $scope.getVehicles({offset: 0, pageSize: 5, field: 'plate_number', direction: 'asc'})
      .then(vehicles => {
        $scope.showInvoiceVehicle = !!vehicles.length;
      });

      workshopAPI.get('system/vehicle_body_types', null, 'bodyTypes')
      .then(types => {
        $scope.body_types = types;
      });
    }
    else if ($scope.vehicle.id) {
      $scope.showInvoiceVehicle = true;
    }

    if ($scope.Invoice && $scope.Invoice.type('internal')) {
      $scope.columns.unshift({
        field : 'stock_number',
        header: {
          text: $translate.instant('DEALERSHIP_SPACE.STOCK_NUMBER')
        }
      });
    }

    workshopAPI.get('/system/state_types', null, 'states')
    .then(states => {
      $scope.states = states;
    });
  };

  $scope.isPlateNumberSearchAvailable = function () {
    return !$rootScope.Company.isDealer()
      && ( $rootScope.Company.hasIntegration('dvla-lookup')
        || $rootScope.Company.hasIntegration('vehicle-registrations')
        || $rootScope.Company.hasIntegration('carfax')
      );
  };

  $scope.save = function (form) {
    $scope.checkPlateNumber(form)
    .then(() => {
      return form.plate_number.duplicate
      ? confirm.generic($translate.instant('JS_SPACE.MESSAGES.VEHICLE_ALREADY_EXISTS', { label: $scope.regoLabel, rego: $scope.vehicle.plate_number }))
      : $q.when(true);
    })
    .then(() => workshopAPI.post('/vehicles', $scope.vehicle, 'vehicle'))
    .then(vehicle => {
      form.$setPristine();

      messages.show($translate.instant('JS_SPACE.MESSAGES.SAVED.VEHICLE'), 'success');

      $scope.vehicleSelected(vehicle);
    })
    .catch(err => {
      messages.error(err);
    });
  };

  $scope.searchRegistration = function () {
    $scope.block.start();

    vehicleRegistrationApi.search($scope.vehicle)
    .then(vehicle => {
      messages.show($translate.instant('JS_SPACE.MESSAGES.VEHICLE_DETAILS_ACQUIRED'), 'success');

      $scope.vehicle = vehicle;
    })
    .catch(err => {
      messages.error(err);
    })
    .finally(() => {
      $scope.block.stop();
    });
  };

  $scope.vehicleFollowUpNotes = function (invoice_id) {
    vehicleApi.viewFollowUpNotes($scope.vehicle, invoice_id, 'invoice');
  };

  $scope.vehicleHistory = function () {
    vehicleHistoryApi.view($scope.vehicle);
  };

  $scope.vehicleHistoryReport = function() {
    vehicleHistoryApi.viewReport($scope.vehicle);
  };

  $scope.viewDiagnosticTool = function() {
    haynesProApi.openDiagnosticTool($scope.vehicle);
  };


  $scope.viewMotHistory = function() {
    dvlaLookupApi.viewMotHistory($scope.vehicle);
  };

  $scope.viewGrid = function (parent) {
    const navigate = function (entity) {
      $state.go(parent === 'event' ? 'app.event' : 'app.invoice', {
        customer_id: entity.customer_id,
        vehicle_id : null,
        id         : entity.id
      });
    };

    if ($scope.vehicle.id && (parent === 'invoice') && $scope.Invoice.form.$dirty) {
      confirm.generic($translate.instant('JS_SPACE.CONFIRM.LOSS_OF_UNSAVED_INFORMATION'))
      .then(() => {
        $scope.Invoice.invoice.vehicle_id = null;

        return $scope.Invoice.save();
      })
      .then(invoice => navigate(invoice))
      .catch(err => {
        messages.error(err);
      });
    }
    else if ($scope.vehicle.id) {
      navigate(parent === 'event' ? $scope.event : $scope.Invoice.invoice);
    }
    else {
      $scope.formContent = ListVehicleHtml;
    }
  };

  $scope.viewTiremetrixPage = function (invoice) {
    $scope.Tiremetrix.getAccessUrl(invoice)
    .then(url => {
      $window.open(url, '_blank');
    })
    .catch(err => {
      messages.error(err);
    });
  };

  $scope.$watch('filtering.value', (newVal, oldVal) => {
    if (newVal !== oldVal) {
      window['filterVehicles']();
    }
  }, true);

  $scope.init();
};